import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { ACCIDENT, AFFECTED_LINES, AFFECTED_STATIONS, BACK, CLOSE, CONSTRUCTION, DEMONSTRATION, DUE_TO, FOR_MORE_INFO, HIDE_ADDITIONAL_INFO, HOLIDAY, IN_LINES, INSTEAD_LINES_WILL_GO_IN_STATIONS, LINE, MAINTENANCE, MEDICAL_EMERGENCY, OTHER_CAUSE, POLICE_ACTIVITY, SHOW_ADDITIONAL_INFO, SIGNIFICANT_DELAYS_WILL_BE_EXPERIENCED, STATIONS_WILL_BE_CANCLED, STRIKE, TECHNICAL_PROBLEM, THERE_MAY_BE_CHANGES, TRIPS_WILL_BE_ADDED, TRIPS_WILL_BE_CANCELLED, UNKNOWN_CAUSE, WEATHER } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { eSpecialMessagesCauses, eSpecialMessagesEffects } from 'src/app/modules/route-planner/constants/special-messages.constants';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';

@Component({
    selector: 'app-special-message-pop-up-detailed',
    templateUrl: './special-message-pop-up-detailed.component.html',
    styleUrls: ['./special-message-pop-up-detailed.component.scss'],
    standalone: false
})
export class SpecialMessagePopUpDetailedComponent implements OnInit {
  @Output() onGoBack = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();

  @Input() selectedMessage: SpecialMessage

  isDesktop: boolean;


  affectedLinesText: string
  affectedStationsText: string
  descText: string
  backText: string
  inLinesText: string
  insteadLinesWillGoText: string
  lineText: string

  showInfoText: string
  hideInfoText: string
  causeText: string
  effectText: string
  dueToText: string
  closeText: string
  forMoreInfoText: string

  backIcon: string

  effects = eSpecialMessagesEffects

  showAdditionalInfo: boolean = false


  constructor(
    private readonly resizeService: ResizeService,
    private readonly utilService: UtilsService,
    private readonly languageService: LanguageService
  ) {

  }

  ngOnInit(): void {
    this.isDesktop = this.resizeService.isDesktop;
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.backIcon = language.direction === "rtl" ? "arrow-right" : "arrow-left"
      this.affectedLinesText = AFFECTED_LINES[language.language]
      this.affectedStationsText = AFFECTED_STATIONS[language.language]
      this.backText = BACK[language.language]
      this.descText = this.utilService.decodeUnicode(this.selectedMessage.desc[language.language]) || this.utilService.decodeUnicode(this.selectedMessage.desc.hebrew)
      this.inLinesText = IN_LINES[language.language]
      this.insteadLinesWillGoText = INSTEAD_LINES_WILL_GO_IN_STATIONS[language.language]
      this.showInfoText = SHOW_ADDITIONAL_INFO[language.language]
      this.hideInfoText = HIDE_ADDITIONAL_INFO[language.language]
      this.dueToText = DUE_TO[language.language]
      this.lineText = LINE[language.language]
      this.closeText = CLOSE[language.language]
      this.forMoreInfoText = FOR_MORE_INFO[language.language]

      switch (this.selectedMessage.effect.id) {
        case eSpecialMessagesEffects.ADDITIONAL_SERVICE:
          this.effectText = TRIPS_WILL_BE_ADDED[language.language]
          break
        case eSpecialMessagesEffects.MODIFIED_SERVICE:
        case eSpecialMessagesEffects.OTHER_EFFECT:
        case eSpecialMessagesEffects.UNKNOWN_EFFECT:
          this.effectText = THERE_MAY_BE_CHANGES[language.language]
          break
        case eSpecialMessagesEffects.DETOUR:
        case eSpecialMessagesEffects.NO_SERVICE:
        case eSpecialMessagesEffects.STOP_MOVED:
          if (this.selectedMessage.allAffectedStops && this.selectedMessage.allAffectedStops.length) {
            this.effectText = `${STATIONS_WILL_BE_CANCLED[language.language]}:`
          } else {
            this.effectText = THERE_MAY_BE_CHANGES[language.language]
          }
          break
        case eSpecialMessagesEffects.REDUCED_SERVICE:
          this.effectText = TRIPS_WILL_BE_CANCELLED[language.language]
          break
        case eSpecialMessagesEffects.SIGNIFICANT_DELAYS:
          this.effectText = SIGNIFICANT_DELAYS_WILL_BE_EXPERIENCED[language.language]
          break
      }

      switch (this.selectedMessage.cause.id) {
        case eSpecialMessagesCauses.ACCIDENT:
          this.causeText = ACCIDENT[language.language]
          break
        case eSpecialMessagesCauses.CONSTRUCTION:
          this.causeText = CONSTRUCTION[language.language]
          break
        case eSpecialMessagesCauses.DEMONSTRATION:
          this.causeText = DEMONSTRATION[language.language]
          break
        case eSpecialMessagesCauses.HOLIDAY:
          this.causeText = HOLIDAY[language.language]
          break
        case eSpecialMessagesCauses.MAINTENANCE:
          this.causeText = MAINTENANCE[language.language]
          break
        case eSpecialMessagesCauses.MEDICAL_EMERGENCY:
          this.causeText = MEDICAL_EMERGENCY[language.language]
          break
        case eSpecialMessagesCauses.POLICE_ACTIVITY:
          this.causeText = POLICE_ACTIVITY[language.language]
          break
        case eSpecialMessagesCauses.STRIKE:
          this.causeText = STRIKE[language.language]
          break
        case eSpecialMessagesCauses.TECHNICAL_PROBLEM:
          this.causeText = TECHNICAL_PROBLEM[language.language]
          break
        case eSpecialMessagesCauses.UNKNOWN_CAUSE:
        case eSpecialMessagesCauses.OTHER_CAUSE:
          this.causeText = UNKNOWN_CAUSE[language.language]
          break
        case eSpecialMessagesCauses.WEATHER:
          this.causeText = WEATHER[language.language]
          break
      }
    })
  }

  isShowAdditionalInfo(): boolean {
    return this.languageService.getSelectedLanguage().language === 'hebrew'
  }

  isShowHeader(): boolean {
    return this.languageService.getSelectedLanguage().language === 'hebrew'
  }

}
